import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow } from "remult";
import { Opportunity } from "../opportunity";
import { type DateAndTimeRange } from "./entity";

export const DateAndTimeRangeEntityConfig: HyperEntityConfig<DateAndTimeRange> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: Roles.All,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      opportunity: {
        $is: await copyApiPrefilterPerRole(Opportunity),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.All, false);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.All, false);
  },
};
